export const cameraView09MastSailsBoomImageOptions = {
  legacy: true,
  prefix: 'X4_9_Exterior',
  angle: 'Camera view 09 - Mast Sails Boom',
  staticOptions: {
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    TeakOnBathingPlatform: 1,
    Boom: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/X49/views/CameraView09MastSailsBoom.js